/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Booking Status
 * @export
 */
export const BookingStatus = {
    Pending: 'pending',
    Accepted: 'accepted',
    Assigned: 'assigned',
    Inactive: 'inactive',
    Canceled: 'canceled',
    Completed: 'completed'
};
export function instanceOfBookingStatus(value) {
    for (const key in BookingStatus) {
        if (Object.prototype.hasOwnProperty.call(BookingStatus, key)) {
            if (BookingStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function BookingStatusFromJSON(json) {
    return BookingStatusFromJSONTyped(json, false);
}
export function BookingStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function BookingStatusToJSON(value) {
    return value;
}
